/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxTemplateKind } from './MailboxTemplateKind';
import {
    MailboxTemplateKindFromJSON,
    MailboxTemplateKindFromJSONTyped,
    MailboxTemplateKindToJSON,
    MailboxTemplateKindToJSONTyped,
} from './MailboxTemplateKind';
import type { MailboxItemOrigin } from './MailboxItemOrigin';
import {
    MailboxItemOriginFromJSON,
    MailboxItemOriginFromJSONTyped,
    MailboxItemOriginToJSON,
    MailboxItemOriginToJSONTyped,
} from './MailboxItemOrigin';
import type { MailboxItemChannel } from './MailboxItemChannel';
import {
    MailboxItemChannelFromJSON,
    MailboxItemChannelFromJSONTyped,
    MailboxItemChannelToJSON,
    MailboxItemChannelToJSONTyped,
} from './MailboxItemChannel';
import type { MailboxTemplateContentDTO } from './MailboxTemplateContentDTO';
import {
    MailboxTemplateContentDTOFromJSON,
    MailboxTemplateContentDTOFromJSONTyped,
    MailboxTemplateContentDTOToJSON,
    MailboxTemplateContentDTOToJSONTyped,
} from './MailboxTemplateContentDTO';

/**
 * 
 * @export
 * @interface MailboxTemplateDTO
 */
export interface MailboxTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateDTO
     */
    Id?: string;
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateDTO
     */
    Key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateDTO
     */
    Name?: string | null;
    /**
     * 
     * @type {MailboxItemChannel}
     * @memberof MailboxTemplateDTO
     */
    Channel?: MailboxItemChannel;
    /**
     * 
     * @type {MailboxItemOrigin}
     * @memberof MailboxTemplateDTO
     */
    Origin?: MailboxItemOrigin;
    /**
     * 
     * @type {MailboxTemplateKind}
     * @memberof MailboxTemplateDTO
     */
    Kind?: MailboxTemplateKind;
    /**
     * 
     * @type {boolean}
     * @memberof MailboxTemplateDTO
     */
    Enabled?: boolean;
    /**
     * 
     * @type {Array<MailboxTemplateContentDTO>}
     * @memberof MailboxTemplateDTO
     */
    Contents?: Array<MailboxTemplateContentDTO> | null;
}



/**
 * Check if a given object implements the MailboxTemplateDTO interface.
 */
export function instanceOfMailboxTemplateDTO(value: object): value is MailboxTemplateDTO {
    return true;
}

export function MailboxTemplateDTOFromJSON(json: any): MailboxTemplateDTO {
    return MailboxTemplateDTOFromJSONTyped(json, false);
}

export function MailboxTemplateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxTemplateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'] == null ? undefined : json['Id'],
        'Key': json['Key'] == null ? undefined : json['Key'],
        'Name': json['Name'] == null ? undefined : json['Name'],
        'Channel': json['Channel'] == null ? undefined : MailboxItemChannelFromJSON(json['Channel']),
        'Origin': json['Origin'] == null ? undefined : MailboxItemOriginFromJSON(json['Origin']),
        'Kind': json['Kind'] == null ? undefined : MailboxTemplateKindFromJSON(json['Kind']),
        'Enabled': json['Enabled'] == null ? undefined : json['Enabled'],
        'Contents': json['Contents'] == null ? undefined : ((json['Contents'] as Array<any>).map(MailboxTemplateContentDTOFromJSON)),
    };
}

export function MailboxTemplateDTOToJSON(json: any): MailboxTemplateDTO {
    return MailboxTemplateDTOToJSONTyped(json, false);
}

export function MailboxTemplateDTOToJSONTyped(value?: MailboxTemplateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'Key': value['Key'],
        'Name': value['Name'],
        'Channel': MailboxItemChannelToJSON(value['Channel']),
        'Origin': MailboxItemOriginToJSON(value['Origin']),
        'Kind': MailboxTemplateKindToJSON(value['Kind']),
        'Enabled': value['Enabled'],
        'Contents': value['Contents'] == null ? undefined : ((value['Contents'] as Array<any>).map(MailboxTemplateContentDTOToJSON)),
    };
}

